// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"66":"9e962f7a","144":"1f170bd9","178":"9e962f7a","425":"9e962f7a","671":"9e962f7a","699":"8406a45f","830":"c027a7ec","993":"9e962f7a"}[chunkId] + ".chunk.css";
};